import compact from "lodash/compact";
import locale from "./buildScriptActionsMenuItems.locale";
export default (script, onOpenScriptEditorPanel, onDeleteScript) => compact([
    {
        text: locale.EDIT_SCRIPT,
        onClick: () => {
            onOpenScriptEditorPanel && onOpenScriptEditorPanel(script);
        },
        icon: "icon-edit"
    },
    {
        text: locale.DELETE_SCRIPT,
        textClassName: "text-red",
        icon: "icon-trash text-red",
        confirm: {
            title: locale.CONFIRM_DELETE_SCRIPT_TEXT,
            header: locale.CONFIRM_DELETE_SCRIPT_HEADER,
            callback: () => {
                onDeleteScript && onDeleteScript(script.Id);
            }
        }
    }
]);
